import React, { useMemo } from 'react'
import { useEffect, useState } from 'react'
import { Link, useLocation, useParams, useSearchParams } from 'react-router-dom'
import { useProjectPermission } from '../../../context/ProjectContext'
import { allTabs } from '../../../routes/allPaths'
import { hasPermission } from '../../../utils/helper'

type Props = {
  breadcrumbData?: any
  page?: string
  parentPage?: string
  disableLinks?: boolean
  clickableIndices?: number[]
}

const Breadcrumb = (props: Props) => {
  const { breadcrumbData, page, parentPage, disableLinks = false, clickableIndices = [0] } = props
  const location = useLocation()
  const params = useParams()
  const { id, name, subName, subId, resourceName, resourceId } = params
  const { projectPermission } = useProjectPermission()

  const [breadcrumbs, setBreadcrumbs] = useState<{ title: string; redirect: string }[]>([])

  useEffect(() => {
    if (breadcrumbData && breadcrumbData.length > 0) {
      //
    } else {
      // Logic to extract breadcrumbs from URL
      const url = location.pathname
      const urlParts = url.split('/').filter((part: any) => part !== '') as any

      const extractedBreadcrumbs = urlParts.map((part: any, index: number) => {
        return {
          title: formatTitle(part),
          redirect: `/${urlParts.slice(0, index + 1).join('/')}`,
        }
      })
      setBreadcrumbs(extractedBreadcrumbs)
    }
  }, [breadcrumbData])

  const formatTitle = (title: string) => {
    return decodeURIComponent(title === subName || title === name ? title?.toUpperCase() : title?.replaceAll('_', ' ')?.replaceAll('-', ' ').toUpperCase())
  }

  const returnSlugPath = useMemo(() => {
    if (page) {
      const foundTab = allTabs?.filter((tab) => tab?.page === (parentPage ? parentPage : page) && hasPermission(projectPermission, tab?.slug, 1))[0]
      return foundTab?.path
        ?.replace(':name', name)
        ?.replace(':subName', subName)
        ?.replace(':id', id)
        ?.replace(':subId', subId)
        ?.replace(':resourceName', resourceName)
        ?.replace(':resourceId', resourceId)
    }
    return ''
  }, [page, allTabs, projectPermission, location?.pathname])

  const [searchParams, setSearchParams] = useSearchParams()
  const queryParamPage = searchParams.get('page')
  const newQuery = queryParamPage ? `?page=${queryParamPage}` : ''

  return (
    <div className="flex items-center text-sm">
      <ul className="flex">
        {breadcrumbData
          ? breadcrumbData?.map((breadcrumb: any, index: number) => (
              <li key={index} className="flex items-center">
                {index < breadcrumbData.length - 1 &&
                formatTitle(breadcrumb.title)?.toLowerCase() !== name?.toLowerCase() &&
                formatTitle(breadcrumb.title)?.toLowerCase() !== subName?.toLowerCase() ? (
                  disableLinks && !clickableIndices.includes(index) ? (
                    <span className="text-black font-bold">
                      {formatTitle(
                        breadcrumb.title?.replace(':name', name)?.replace(':subName', subName)?.replace(':subId', subId)?.replace(':resourceName', resourceName)?.replace(':resourceId', resourceId),
                      )?.replace('NAI', 'nAI')}
                    </span>
                  ) : (
                    <Link
                      to={`${
                        breadcrumb?.redirect?.includes(':slug')
                          ? returnSlugPath
                          : breadcrumb.redirect
                              ?.replace(':name', name)
                              ?.replace(':subName', subName)
                              ?.replace(':id', id)
                              ?.replace(':subId', subId)
                              ?.replace(':resourceName', resourceName)
                              ?.replace(':resourceId', resourceId)
                      }${newQuery}`}
                      state={location?.state}
                      className="text-black font-bold hover:underline"
                    >
                      {formatTitle(
                        breadcrumb.title?.replace(':name', name)?.replace(':subName', subName)?.replace(':subId', subId)?.replace(':resourceName', resourceName)?.replace(':resourceId', resourceId),
                      )?.replace('NAI', 'nAI')}
                    </Link>
                  )
                ) : (
                  <span className={`text-black  font-bold ${breadcrumb.title?.toLowerCase()?.includes('nai') ? '' : 'uppercase'}`}>
                    {formatTitle(
                      breadcrumb.title?.replace(':name', name)?.replace(':subName', subName)?.replace(':subId', subId)?.replace(':resourceName', resourceName)?.replace(':resourceId', resourceId),
                    )?.replace('NAI', 'nAI')}
                  </span>
                )}
                {index < breadcrumbData.length - 1 && <span className="mx-1 md:mx-2  font-bold">{'>'}</span>}
              </li>
            ))
          : breadcrumbs?.map((breadcrumb: any, index: number) => (
              <React.Fragment key={index}>
                {formatTitle(breadcrumb?.title) === formatTitle(`${id || ''}`) ||
                formatTitle(breadcrumb?.title) === formatTitle(`${subId || ''}`) ||
                formatTitle(breadcrumb?.title) === formatTitle(`${resourceId || ''}`) ? (
                  ''
                ) : (
                  <li className="flex items-center">
                    {index < breadcrumbs.length - 1 &&
                    formatTitle(breadcrumb.title)?.toLowerCase() !== name?.toLowerCase() &&
                    formatTitle(breadcrumb.title)?.toLowerCase() !== subName?.toLowerCase() ? (
                      disableLinks && !clickableIndices.includes(index) ? (
                        <span className="text-black font-bold uppercase">
                          {formatTitle(breadcrumb.title?.replace(':name', name)?.replace(':subName', subName)?.replace(':resourceName', resourceName))}
                        </span>
                      ) : (
                        <Link to={`${breadcrumb.redirect}${newQuery}`} state={location?.state} className="text-black font-bold hover:underline">
                          {formatTitle(breadcrumb.title?.replace(':name', name)?.replace(':subName', subName)?.replace(':resourceName', resourceName))}
                        </Link>
                      )
                    ) : (
                      <span className="text-black font-bold uppercase">
                        {formatTitle(breadcrumb.title?.replace(':name', name)?.replace(':subName', subName)?.replace(':resourceName', resourceName))}
                      </span>
                    )}
                    {index < breadcrumbs.length - 1 && <span className="mx-2 font-bold">{'>'}</span>}
                  </li>
                )}
              </React.Fragment>
            ))}
      </ul>
    </div>
  )
}

export default Breadcrumb
